import { render, staticRenderFns } from "./GridEditButton.vue?vue&type=template&id=581c2126&"
import script from "./GridEditButton.vue?vue&type=script&lang=ts&"
export * from "./GridEditButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports